import ProductInventoryTypeEnum = Meevo.Model.ProductInventoryTypeEnum;
import ProductPackageTypeEnum = Meevo.Model.ProductPackageTypeEnum;

namespace Meevo.Model {

    export interface ProductVariant {
        displayName: string;
        id: string;
        objectState: ObjectStateEnum;
        markUp: number;
        wholeSale: number;
        retail: number;
        notForSale: boolean;
        excludePointPromotion: boolean;
        sortOrder: number;
        productInventoryType: ProductInventoryTypeEnum;
        isInventoryTrackable: number;
        floorLocation: string;
        floorLocations: any[]; // TODO: Determine actual element type for all 'any' types
        noOfWeeksValid: number;
        variantDistributorIds: any[];
        variantStockLevels: VariantStockLevel[];
        consolidatedNameFragment1?: string;
        consolidatedNameFragment2?: string;
        consolidatedNameFragment3?: string;
        previousInformation: string;
        alreadyConsolidated: boolean;
        variantAttributes: ProductVariantAttribute[];
    }

    export interface VariantStockLevel {
        variantId: string;
        productPackageType: ProductPackageTypeEnum;
        productInventoryType: ProductInventoryTypeEnum;
        multiplesOf: number;
        modelQuantity: number;
        orderPoint: number;
        onHand: number;
        wasChanged: boolean,
        isDisplayed: boolean;
    }

}